import { useTranslation } from 'react-i18next'
import { useApp } from '../hooks/useApp'
import { TopTitle } from '../components/atoms/TopTitle'
import { PageTitle } from '../components/atoms/PageTitle'
import { callAxios } from '../hooks/useAxios'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { Widget, WidgetData } from '../classes/widgets/Widget'
import { getWidget } from '../classes/widgets'
import { WidgetGrid } from '../components/WidgetGrid'
import { useDevices } from '../hooks/useDevices'

export function WidgetsPage() {
  const app = useApp()
  const { t } = useTranslation()
  const [widgets, setWidgets] = useState<Widget[]>([])
  const { control } = useDevices()

  async function refresh() {
    for (const location of app.locations) {
      const resp = await callAxios<WidgetData[]>({
        url: `/widgets?location=${location.id}`,
      })
      if (resp.success) {
        setWidgets(resp.data.map(widget => getWidget(widget, control, app)))
      }
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { refresh() }, [])

  return (
    <>
      <TopTitle title={t('Widgets')}></TopTitle>
      {app.locations.map(location => <Box key={location.id}>
        <PageTitle title={location.name}/>
        <WidgetGrid configure widgets={widgets} onRefresh={() => refresh()}/>
      </Box>)}
    </>
  )
}
